import React from 'react';
import HighlightsCard from '../HighlightsCard';
import { useTileData } from '../../../hooks/useTileData';
import { getGoogleAdsKpis } from '../../../api';
import { fmtRatio } from '../../shared/format';

// Google Ads' own thresholds — matches VerdictCard.js and the industry norm.
// <1 = burning cash, 1-2 = weak, 2-4 = healthy, 4+ = strong.
const captionFor = (roas) => {
  if (!Number.isFinite(roas)) return 'Ad-spend efficiency';
  if (roas >= 4) return 'Strong return';
  if (roas >= 2) return 'Healthy';
  if (roas >= 1) return 'Weak';
  return 'Losing money';
};

export default function RoasHighlight({ clientId, rangeStart, rangeEnd }) {
  const { data, loading, error } = useTileData(
    async () => {
      const resp = await getGoogleAdsKpis(clientId, rangeStart, rangeEnd);
      return resp?.data ?? null;
    },
    [clientId, rangeStart, rangeEnd],
    Boolean(clientId && rangeStart && rangeEnd),
  );

  const roas = data?.roas != null ? Number(data.roas) : null;
  const prevRoas = data?.previous_period?.roas != null ? Number(data.previous_period.roas) : null;
  const delta = prevRoas > 0 ? ((roas - prevRoas) / prevRoas) * 100 : null;

  return (
    <HighlightsCard
      label="ROAS"
      value={roas != null ? fmtRatio(roas) : '—'}
      delta={delta}
      caption={captionFor(roas)}
      loading={loading}
      error={error}
    />
  );
}
